import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import StepContent from "../../step-content";
import ExecutionSuccessImage from "./success.svg";
import GoToAccountLink from "../../go-to-account-link";
import messages from "./success-messages";

import "./success.scss";

const block = "execution-success";

const Success = ({ intl: { formatMessage } }) => {
  return (
    <StepContent
      stepTitle={formatMessage(messages.thankYou)}
      imageUrl={ExecutionSuccessImage}
    >
      <div className={block}>
        <p className={`${block}__information`}>
          <FormattedMessage {...messages.emailSent} />
        </p>
        <GoToAccountLink />
      </div>
    </StepContent>
  );
};

export { Success };
export default injectIntl(Success);
